import axios from 'axios';

// 扫码授权三接口是公开的（用户此刻还没有任何身份），
// 因此用独立 axios 实例，避开 utils/request.js 的全局拦截器
// （它会在 401 时刷新管理端 token 并强跳 /login，与访客场景不符）。
const raw = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' }
});

raw.interceptors.response.use(
  response => {
    if (response.data && response.data.success) {
      return response.data;
    }
    throw response.data;
  },
  error => {
    throw error;
  }
);

export default {
  /**
   * 生成扫码票据 + 小程序码
   * @param {string} biz 业务标识：memberApply（会员入会申请）/ mediationApply（调解申请）/ contact（在线留言）
   */
  createTicket(biz = 'memberApply') {
    return raw.get('/auth/qr/ticket', { params: { biz } });
  },

  /** 轮询授权状态；CONFIRMED 时一并返回 accessToken / refreshToken */
  pollStatus(ticket) {
    return raw.get('/auth/qr/status', { params: { ticket } });
  }
};
